import React from "react";
import { Typography, Form } from "antd";
import styles from "./fee.module.css";
import {
  GpmThreshold,
  PricingType,
  PricingTypeLabels,
  PricingLevel,
  Gpm as GpmDataType,
} from "../../data-types";
import { AddPricingTooltip } from "./add-pricing-tooltip";
import { AlterCalculatedPriceTooltip } from "./alter-calculated-price-tooltip";
import { SidebarPriceInputSingle } from "./sidebar-price-input-single";
import { Gpm } from "./gpm";
import { GpmSlider } from "../gpm-slider";
import { useGpmSettingsCheck } from "~/hooks";

const {
  number: numberClassName,
  ["gpm-slider-only"]: gpmSliderOnlyClassName,
  ["gpm-slider-with-percentage"]: gpmSliderWithPercentageClassName,
} = styles as any;

type FeeProps = {
  gpm: GpmDataType;
  gpmThreshold: GpmThreshold;
  onChosenPriceChange: (arg0: number) => void;
  suggested: number | null;
  chosen: number | null;
  pricingType: PricingType;
  pricingLevel: PricingLevel;
  currencySymbol: string;
  isFeeEarnerLevelGpm: boolean;
};

export const Fee: React.FC<FeeProps> = ({
  gpm,
  gpmThreshold,
  onChosenPriceChange,
  suggested,
  chosen,
  pricingType,
  pricingLevel,
  currencySymbol,
  isFeeEarnerLevelGpm,
}) => {
  if (pricingType === PricingType.None) return null;
  const { showGpm, showGpmSlider } = useGpmSettingsCheck();
  return (
    <>
      <Form.Item label="Pricing">{PricingTypeLabels[pricingType]}</Form.Item>
      {pricingType !== PricingType.TopDown && (
        <Form.Item label="Calculated">
          {pricingLevel === PricingLevel.FeeEarner ? (
            <AlterCalculatedPriceTooltip>
              <Typography.Text className={numberClassName}>
                {currencySymbol}
                {(suggested || 0).toLocaleString()}
              </Typography.Text>
            </AlterCalculatedPriceTooltip>
          ) : (
            <AddPricingTooltip>Not Available</AddPricingTooltip>
          )}
        </Form.Item>
      )}
      <Form.Item label="User Defined">
        <SidebarPriceInputSingle
          phaseLevelPricing={pricingLevel === PricingLevel.Phase}
          topDownPricing={pricingType === PricingType.TopDown}
          currencySymbol={currencySymbol}
          onChange={(newValue) => {
            if (newValue !== chosen) {
              onChosenPriceChange(newValue);
            }
          }}
          chosen={chosen}
          disabled={pricingLevel !== PricingLevel.Matter || pricingType === PricingType.TopDown}
        />
      </Form.Item>
      {showGpm && (
        <Form.Item label="GPM">
          <Gpm isFeeEarnerLevelGpm={isFeeEarnerLevelGpm} gpm={gpm} gpmThreshold={gpmThreshold} />
        </Form.Item>
      )}
      {!(showGpm && gpm == null) &&
        showGpmSlider &&
        gpmThreshold.gpmDangerThreshold &&
        gpmThreshold.gpmWarningThreshold && (
          <Form.Item
            label={showGpm ? undefined : "GPM"}
            className={showGpm ? gpmSliderWithPercentageClassName : ""}
          >
            <div className={showGpm ? "" : gpmSliderOnlyClassName}>
              <GpmSlider
                showGpm={showGpm}
                gpmThreshold={gpmThreshold}
                gpm={gpm}
                isFeeEarnerLevelGpm={isFeeEarnerLevelGpm}
              />
            </div>
          </Form.Item>
        )}
    </>
  );
};
